import { MarqueeBar } from "./MarqueeBar";
import HOME_CMS from "../../content/pages/home.json";

// First CMS-wired field of the orphan pages/home.json file. Editing this
// list in Decap actually updates the home marquee. Hardcoded list stays as
// a safe fallback if the JSON is malformed.
const FALLBACK_ITEMS = [
  "300+ références",
  "13 gammes",
  "Depuis 2009",
  "BPI France Excellence",
  "Livraison 24h IDF · France selon zone",
  "Sans rupture",
  "23 marques",
  "B2B premium",
];
const ITEMS = Array.isArray(HOME_CMS?.marquee_stats) && HOME_CMS.marquee_stats.length
  ? HOME_CMS.marquee_stats
  : FALLBACK_ITEMS;

/**
 * MarqueeStats — golden stats bar between hero and next section.
 */
export const MarqueeStats = () => (
  <section
    data-testid="marquee-stats"
    className="relative bg-fd-gold text-black py-5 border-y border-black/10 overflow-hidden"
  >
    <MarqueeBar speed="slow">
      {ITEMS.map((it, i) => (
        <div key={i} className="flex items-center px-8 shrink-0">
          <span className="font-display text-base md:text-lg uppercase tracking-tight">{it}</span>
          <span className="mx-8 text-black/50 font-mono text-xs">✦</span>
        </div>
      ))}
    </MarqueeBar>
  </section>
);
